import React, { Component } from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import "./App.css";
import DashboardScreen from "./screens/DashboardScreen";
import LoginScreen from "./screens/LoginScreen";
import { EventEmitter } from "../app/events/EventEmitter";
import SnackBarComponent, {
  SNACKBAR_TYPE,
} from "./components/SnackBarComponent";
import AuthUtils from "./auth/AuthUtils";
import LoadingComponents from "./components/LoadingComponents";
import CompaniesScreen from "./screens/CompaniesScreen";
import CompanyScreen from "./screens/CompanyScreen";
import history from "./utils/history";
import { StylesProvider, ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import pink from "@material-ui/core/colors/indigo";
import red from "@material-ui/core/colors/red";
import { AuthenticationService } from "./services/AuthenticationService";
import { AuthProvider, AuthConsumer } from "./routes/AuthContext";
import HasPermission from "./auth/HasPermission";
import { ROLES } from "./constants/constants";
import MainDashboard from "./screens/MainDashboard";
import UnauthorisedScreen from "./screens/UnauthorisedScreen";
import ForgotPasswordScreen from "./screens/ForgotPasswordScreen";
import { ConfigurationService } from "./services/ConfigurationService";
import StateContext from "./routes/StateProvider";
import GridLoader from "react-spinners/GridLoader";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { css } from "@emotion/core";
const defaultTheme = createMuiTheme({
  palette: {
    primary: pink,
    secondary: red,
  },
});

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class App extends Component {
  state = {
    isLoading: false,
    showSnackBar: { show: false, type: "", message: "" },
    user: { role: "", companyId: "" },
    authenticated: false,
    forgotpassword: false,
    accessRules: new Array<any>(),
  };
  onLoginSuccess = (loginResp: any) => {
    this.setSession({
      user: loginResp.user,
      authenticated: true,
    });
  };

  onForgotPassword = () => {
    this.setState({
      forgotpassword: true,
    });
  };

  onSnackBarClose = () => {
    this.setState({
      showSnackBar: { show: false, type: "", message: "" },
    });
  };
  componentDidMount = async () => {
    let resp = await AuthUtils.getAuthenticatedInUser();
    if (resp) {
      this.setState(
        {
          user: resp.user,
          authenticated: true,
        },
        () => {
          this.getConfigurationAccess();
          this.setSession({
            user: this.state.user,
            authenticated: true,
          });
        }
      );
    } else {
      this.redirect();
    }
    EventEmitter.subscribe(
      EventEmitter.events.SEND_SNACK_MESSAGE,
      (obj: any) => {
        this.setState({
          showSnackBar: { show: true, type: obj.type, message: obj.message },
        });
      }
    );
    EventEmitter.subscribe(EventEmitter.events.SEND_LOGIN_REQUEST, () => {
      this.setState({
        authenticated: false,
      });
    });
    EventEmitter.subscribe(EventEmitter.events.START_LOADING_REQUEST, () => {
      this.setState({
        isLoading: true,
      });
    });
    EventEmitter.subscribe(EventEmitter.events.STOP_LOADING_REQUEST, () => {
      this.setState({
        isLoading: false,
      });
    });
  };
  redirect = (path?: any, mState?: any) => {
    history.push({
      pathname: path ? path : `/segpi/login`,
      state: mState ? mState : {},
    });
  };

  updateAccessRules = (accessRules: any) => {
    this.setState({ accessRules });
  };

  redirectToDashboard = () => {
    let paramObj = {
      profileData: this.state.user,
      companyId: this.state.user.companyId,
    };
    history.push({
      pathname: `/segpi/dashboard`,
      state: paramObj,
    });
  };

  redirectToForgotPassword = () => {
    history.push({
      pathname: `/segpi/forgotpassword`,
      state: {},
    });
    return <ForgotPasswordScreen onLogin={this.onLogin} />;
  };
  onLogin = () => {
    history.goBack();
    this.setState(
      {
        forgotpassword: false,
      },
      () => {
        this.redirect();
        window.location.reload();
      }
    );
  };

  setSession = (data: any) => {
    this.setState({
      authenticated: true,
      user: data.user,
    });
  };

  initiateLogin = (values: any, loginType: any, dashboardUser: any) => {
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    let authenticationService: AuthenticationService = new AuthenticationService();
    let jsonBody = {};
    if (loginType === "EMAIL") {
      jsonBody = {
        loginType: loginType,
        email: values.email,
        password: values.password,
      };
    } else {
      jsonBody = {
        loginType: loginType,
        employeeNumber: values.employeeNumber,
        password: values.password,
      };
    }

    authenticationService.login(jsonBody, dashboardUser).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.success === true) {
        this.onLoginSuccess(resp);
        this.getConfigurationAccess();
      }
      if (resp && resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
      if (resp && resp.message) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.message,
        });
      }
    });
  };
  getConfigurationAccess = () => {
    let configurationService: ConfigurationService = new ConfigurationService();
    configurationService.getAccess().then((resp) => {
      if (resp && resp.success && resp.data) {
        this.setState({
          accessRules: resp.data,
        });
      }
    });
  };
  onLogOut = async () => {
    await AuthUtils.logout();
    this.setState(
      {
        authenticated: false,
        user: null,
        accessRules: new Array<any>(),
      },
      () => {
        history.replace({ pathname: "/segpi/login" });
      }
    );
  };
  render() {
    const authProviderValue = {
      ...this.state,
      initiateLogin: this.initiateLogin,
      handleAuthentication: this.onLoginSuccess,
      logout: this.onLogOut,
    };
    return (
      <DndProvider backend={HTML5Backend}>
        <AuthProvider value={authProviderValue}>
          <StylesProvider injectFirst>
            <ThemeProvider theme={defaultTheme}>
              <StateContext.Provider value={this.state.accessRules}>
                <AuthConsumer>
                  {({ authenticated, user, accessRules }) => {
                    if (!user || accessRules.length === 0) {
                      return (
                        <div>
                          {!this.state.forgotpassword ? (
                            <div>
                              {accessRules.length === 0 && user ? (
                                <div
                                  style={{
                                    position: "fixed" /* or absolute */,
                                    top: "50%",
                                    left: "50%",
                                  }}
                                >
                                  <GridLoader
                                    css={override}
                                    size={12}
                                    margin={2}
                                    color={"#f96500"}
                                    loading={true}
                                  />
                                </div>
                              ) : (
                                <LoginScreen
                                  onLoginSuccess={this.onLoginSuccess}
                                  onForgotPassword={this.onForgotPassword}
                                />
                              )}
                            </div>
                          ) : (
                            <ForgotPasswordScreen onLogin={this.onLogin} />
                          )}
                        </div>
                      );
                    } else {
                      return (
                        <div className="App">
                          <Router history={history}>
                            {this.state.showSnackBar &&
                              this.state.showSnackBar.show && (
                                <SnackBarComponent
                                  type={this.state.showSnackBar.type}
                                  open={this.state.showSnackBar.show}
                                  onClose={this.onSnackBarClose}
                                  message={this.state.showSnackBar.message}
                                />
                              )}
                            <Switch>
                              <Route exact path="/segpi/login">
                                {authenticated ? (
                                  user.role === "DASHBOARD" ? (
                                    <Redirect to="/segpi/dashboard" />
                                  ) : (
                                    <Redirect to="/segpi" />
                                  )
                                ) : this.state.forgotpassword ? (
                                  <ForgotPasswordScreen
                                    onLogin={this.onLogin}
                                  />
                                ) : (
                                  <LoginScreen
                                    onLoginSuccess={this.onLoginSuccess}
                                    onForgotPassword={this.onForgotPassword}
                                  />
                                )}
                              </Route>
                              <Route exact path="/segpi">
                                {!authenticated ? (
                                  <Redirect to="/segpi/login" />
                                ) : (
                                  <HasPermission
                                    role={user.role}
                                    accessRules={accessRules}
                                    perform="main-dashboard:view"
                                    yes={() => (
                                      <DashboardScreen profileData={user} />
                                    )}
                                    no={() => (
                                      <Redirect to="/segpi/companies" />
                                    )}
                                  />
                                )}
                              </Route>
                              <Route exact path="/segpi/companies">
                                <HasPermission
                                  role={user.role}
                                  accessRules={accessRules}
                                  perform="companies:view"
                                  yes={() => {
                                    if (user.companyId) {
                                      return (
                                        <CompanyScreen
                                          location={{
                                            state: {
                                              profileData: user,
                                              companyId: user.companyId,
                                            },
                                          }}
                                        />
                                      );
                                    } else {
                                      return (
                                        <CompaniesScreen
                                          companies={{}}
                                          onItemClicked={{}}
                                          updateToolBarButton={{}}
                                          profileData={this.state.user}
                                        />
                                      );
                                    }
                                  }}
                                  no={() => {
                                    if (user.companyId) {
                                      return (
                                        <Redirect
                                          push
                                          to={{
                                            pathname: "/segpi/company",
                                            state: {
                                              profileData: user,
                                              companyId: user.companyId,
                                            },
                                          }}
                                        />
                                      );
                                    } else {
                                      return (
                                        <Redirect to={"/segpi/unauthorised"} />
                                      );
                                    }
                                  }}
                                />
                              </Route>
                              <Route
                                exact
                                path="/segpi/companies/company"
                                component={CompanyScreen}
                              />
                              <Route exact path="/segpi/company">
                                <HasPermission
                                  role={user.role}
                                  accessRules={accessRules}
                                  perform="company:view"
                                  yes={() => (
                                    <CompanyScreen
                                      location={{
                                        state: {
                                          profileData: user,
                                          companyId: user.companyId,
                                        },
                                      }}
                                    />
                                  )}
                                  no={() =>
                                    user.role === ROLES.DASHBOARD ? (
                                      <Redirect to={"/segpi/dashboard"} />
                                    ) : (
                                      <Redirect to={"/segpi/unauthorised"} />
                                    )
                                  }
                                ></HasPermission>
                              </Route>
                              <Route
                                exact
                                path="/segpi/dashboard"
                                render={(props) => {
                                  return (
                                    <HasPermission
                                      role={user.role}
                                      accessRules={accessRules}
                                      perform="dashboard:view"
                                      yes={() => (
                                        <MainDashboard
                                          location={props.location}
                                          profileData={user}
                                          onLogOut={this.onLogOut}
                                        />
                                      )}
                                      no={() => (
                                        <MainDashboard
                                          location={props.location}
                                          profileData={user}
                                          onLogOut={this.onLogOut}
                                        />
                                      )}
                                    />
                                  );
                                }}
                              ></Route>
                              <Route exact path="/segpi/forgotpassword">
                                <ForgotPasswordScreen onLogin={this.onLogin} />
                              </Route>
                              <Route exact path="/segpi/unauthorised">
                                <UnauthorisedScreen profileData={user} />
                              </Route>
                            </Switch>
                            <LoadingComponents
                              isLoading={this.state.isLoading}
                            />
                          </Router>
                        </div>
                      );
                    }
                  }}
                </AuthConsumer>
              </StateContext.Provider>
            </ThemeProvider>
          </StylesProvider>
        </AuthProvider>
      </DndProvider>
    );
  }
}
export default App;
